import axios from "axios";

export default {
  getNotifications(context) {
    axios
      .get("notifications", {
        headers: {
          "Accept-Language": "ar",
        },
      })
      .then((res) => {
        context.commit("setNotifications", res.data.data.notifications);
        context.commit("setUnread", res.data.data.unread_notifications_count);
      });
  },
};
